import type { FilterProps } from '../../Filters';

export const HouseRulesFilter = ({ filters, onFilterChanged }: FilterProps) => {
    const handleChange = (checkedItem: string) => {
        const tempHouseRules = filters.house_rules || [];
        const tempList = Array.isArray(tempHouseRules) ? tempHouseRules : [tempHouseRules];
        const newFilters = tempList.includes(checkedItem) ? tempList.filter((item) => item !== checkedItem) : [...tempList, checkedItem];

        onFilterChanged({ house_rules: newFilters });
    };

    return (
        <>
            <div className="input-toggle">
                <input
                    id="wheelchairAccessible"
                    data-testid="houseRuleWheelchair"
                    type="checkbox"
                    checked={filters.house_rules?.includes('wheelchairAccessible')}
                    value="wheelchairAccessible"
                    onChange={() => handleChange('wheelchairAccessible')}
                />
                <label htmlFor="wheelchairAccessible">
                    <span>Rullestolvennlig</span>
                </label>
                <input
                    id="petsAllowed"
                    data-testid="houseRulePets"
                    type="checkbox"
                    checked={filters.house_rules?.includes('petsAllowed')}
                    value="petsAllowed"
                    onChange={() => handleChange('petsAllowed')}
                />
                <label htmlFor="petsAllowed">
                    <span>Kjæledyr tillatt</span>
                </label>
                <input
                    id="smokingAllowed"
                    type="checkbox"
                    checked={filters.house_rules?.includes('smokingAllowed')}
                    value="smokingAllowed"
                    onChange={() => handleChange('smokingAllowed')}
                />
                <label htmlFor="smokingAllowed">
                    <span>Røyking tillatt</span>
                </label>
            </div>
        </>
    );
};
